<template lang="html">
  <div class="wxOpen" v-html="html"></div>
</template>
<script>
export default {
  props: {
    username: "",
    path: "",
    content:"",
  },
  data() {
    return {
      html: "",
    };
  },
  mounted() {
    if (this.username) {
      this.setHtml();
    }
  },
  methods: {
    // 设置按钮html
    setHtml() {
      let temp = this.content;
      let html = `<wx-open-launch-weapp id="launch-btn" style="display:block;width:100%;height:100%;" username="${this.username}" path="${this.path}"><template>${temp}</template></wx-open-launch-weapp>`;
      this.html = html;
      this.$nextTick(()=>{
          this.getlaunch();
      })
    },
    // 检测是否成功
    getlaunch(){
        var btn = document.getElementById('launch-btn');
        btn.addEventListener('launch', function (e) {
            console.log('xcxsuccess');
        });
        btn.addEventListener('error', function (e) {
            console.log('xcxfail', e.detail);
        });
    }
  },
  watch: {
    username(newVal) {
      if (newVal) {
        console.log(111);
        this.setHtml();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wxOpen {
   position: absolute;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   z-index: 10;
}
.open-template {
  display: none;
}
</style>